// Copyright 2020 Drivetrain Hub LLC
// GraphQL handlers for frame data.

// import helper from "./helper";
// import lib from "./lib";

import helper from "./helper";
import lib from "./lib";

const FRAME_INFO = {
  // <param prop>: [<description>, <symbol>, <unit type>]
  pitchCircleDiameter: ['Pitch circle diameter', '$d_p$', 'length'],
};
const FRAME_KEYS = Object.keys(FRAME_INFO);

/**
 * Lookup the description, symbol and units of a frame parameter.
 * @param {string} paramStr - Frame parameter to lookup.
 * @return {{desc: *, symbol: *, units: *}} Frame parameter info.
 */
function lookupFrameInfo(paramStr) {
  return helper.lookupParamInfo(FRAME_INFO, FRAME_KEYS, paramStr);
}

/**
 * Create an object for tabulating carrier geometry parameter data.
 * @param {Object} frame - Frame library object.
 * @param {Object} units - Optional labeling for units.  Units are *not* be converted by this function.
 * @return {{parameter: string, symbol: string, value: number || string, units: string}[]} Array with props required by LibTableParams.vue.
 */
function tableCarrierGeom(frame, units) {
  return lib.libTableParams(frame.geom, lookupFrameInfo, units);
}

export default {
  tableCarrierGeom: tableCarrierGeom,
}
